/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
export * from './lib/main-shell.routes';
